import React, { useState } from 'react';
import './statistics.css';
import GenDaily from './report/GenDaily';
import GenMonth from './report/GenMonth';

import '../../App.css';

function Statistics() {
  const [activeTab, setActiveTab] = useState('일일발전량'); // 기본적으로 '시간발전량' 탭 선택

  // 탭 클릭 시 해당 탭을 활성화하는 함수
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  // 각 탭에 따른 콘텐츠 렌더링
  const renderContent = () => {
    switch (activeTab) {
      case '시간발전량':
        return <div style={{margin:'20px'}}>상단 계측장비메뉴 이동 후 각 장비 하단 그래프에서 조회바랍니다.</div>; 
      case '일일발전량':
        return <GenDaily/>;
      case '월간발전량':
        return <GenMonth/>;
      default:
        return null;
    }
  };

  return (
    <div className="main-Public-wrap">
      <div className="report-wrap">
        {/* 탭 메뉴 */}
        <div className="tab-menu">
          <div
            className={`tab-item ${activeTab === '시간발전량' ? 'active' : ''}`}
            onClick={() => handleTabClick('시간발전량')}
          >
            시간발전량
          </div>
          <div
            className={`tab-item ${activeTab === '일일발전량' ? 'active' : ''}`}
            onClick={() => handleTabClick('일일발전량')}
          >
            일일발전량
          </div>
          <div
            className={`tab-item ${activeTab === '월간발전량' ? 'active' : ''}`}
            onClick={() => handleTabClick('월간발전량')}
          >
            월간발전량
          </div>
        </div>

        {/* 선택된 탭의 콘텐츠 */}
        <div className="chart-container" style={{background:'white'}}>
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default Statistics;
